export class Inscricao {
    public id: number;
    public pessoa: number;
    public dataInclusao: Date;
    public situacao: number;
    public periodo: number;
    public respostaQuestionario: number;

    //variáveis transient
    public nome: string;
    public situacaoDenominacao: string;



}
